import { handleError } from '~/ErrorHandler';
import { fetchMoreProductHistory } from '~/ProductHistory';
import { ThunkAction } from '~/Store';

export function fetch(productId: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		try {
			await dispatch(fetchMoreProductHistory(productId));
		} catch (error) {
			dispatch(handleError(error));
		}
	};
}
